import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Clock } from "lucide-react";
import { COMPANY } from "../mock";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0a2540] to-[#1e40af] text-white py-16">
        <div className="container-x">
          <div className="text-xs uppercase tracking-[3px] opacity-80">Contact</div>
          <h1 className="brand-serif text-4xl md:text-5xl font-extrabold mt-2">Get In Touch</h1>
          <div className="text-sm mt-4 opacity-80"><Link to="/" className="hover:text-amber-300">Home</Link> / Contact Us</div>
        </div>
      </section>

      <section className="section">
        <div className="container-x grid md:grid-cols-3 gap-6">
          {[
            { icon: MapPin, title: "Head Office", lines: [COMPANY.address] },
            { icon: Mail, title: "Email Us", lines: [COMPANY.email] },
            { icon: Phone, title: "Call Us", lines: COMPANY.phones.map(p => `${p.label}: ${p.number}`) },
            { icon: Clock, title: "Working Hours", lines: ["Sun – Thu: 9:00 AM – 6:00 PM", "Fri – Sat: Closed"] },
          ].map((c) => (
            <div key={c.title} className="p-6 rounded-xl bg-[#eff6ff] border border-slate-100 hover:shadow-md transition-shadow">
              <div className="w-14 h-14 rounded-full bg-white text-[#1e40af] flex items-center justify-center shadow-sm">
                <c.icon size={22} />
              </div>
              <h4 className="text-[#0a2540] font-bold mt-4">{c.title}</h4>
              {c.lines.map((l, i) => (
                <p key={i} className="text-sm text-slate-600 mt-1 leading-relaxed">{l}</p>
              ))}
            </div>
          ))}
        </div>

        <div className="container-x grid md:grid-cols-2 gap-10 mt-16">
          <div>
            <div className="section-eyebrow">Send Message</div>
            <h2 className="section-title mt-2">We'd love to hear from you</h2>
            <p className="text-slate-600 mt-4 leading-relaxed">Whether you have a project to fund, a trade to finance, or need advisory - our consultants are ready to help. Reach out and one of our team members will respond within one business day.</p>
            <div className="mt-8 rounded-2xl overflow-hidden shadow-lg border-4 border-white h-[380px]">
              <iframe
                title="Fortunexis Office Location"
                src="https://maps.google.com/maps?q=HDS%20Business%20Center%20JLT%20Dubai&t=&z=15&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
              />
            </div>
          </div>
          <ContactForm />
        </div>
      </section>
    </div>
  );
}
